<template lang="pug">
span.phone
  span(v-if='!checkPhoneValidity(value)') {{ value }}
  span.fragment(v-else v-for='(i, index) in fragment' :key='index') {{ i }}
</template>

<script>
export default {
  props: ['value'],
  computed: {
    fragment () {
      const value = this.value
      if (!this.checkPhoneValidity(value)) return []

      const string = value + '' // 將內容強制轉型成字串
      const rule = [0, 4, 7, 10] // 電話號碼的分割規則(切割位置)
      const list = [] // 分割後的結果

      rule.forEach((digit, index) => {
        const nextDigit = rule[index + 1] || null
        if (!nextDigit) return
        list.push(string.substring(digit, nextDigit))
      })

      return list
    },
  },
}
</script>

<style scoped lang="sass">
.phone
  white-space: nowrap
// 電話號碼分割線
span.fragment
  &:not(:last-child)::after
    content: '-'
    color: grey
    letter-spacing: 0
</style>
